module.exports = __webpack_public_path__ + "static/media/infortuni-lavoro.0bbaa3b2.jpg";